import React, { useState, useEffect, useRef } from 'react';
import FlashcardList from './FlashcardList';
import './App.css'
import { Link } from 'react-router-dom';

function App() {
  const [flashcards, setFlashcards] = useState(EDURAW_FLASHCARDS)
  const [teamNumber, setTeamNumber] = useState('ONE')
  
  useEffect(() => {
   
  }, [])

  const clicked = 0

  function nextButton(e) {
    const clicked =  1;
  }
    

  return (
    <>
      
      <div className="headerTeampicker" >
          <div>
            <h1>Game Picker</h1>
          </div>
          <div>
          </div>
  
      </div>
      
      <div className="container">
        <FlashcardList flashcards={flashcards} />
      </div>
      
    </>
  );
}

const EDURAW_FLASHCARDS = [
  {
    id: 'gold',
    answer: 'Iron',
    link: 'https://eduraw-toolkit-en-cu.vercel.app/single',
  },   
  {
    id: 'silicon',
    answer: 'Silicon',
    link: 'https://eduraw-toolkit-en.vercel.app/single',
  },
  {
    id: 'gold',
    answer: 'Copper',
    link: 'https://eduraw-toolkit-cu-si-en.vercel.app/single',
  },   
  {
    id: 'silicon',
    answer: 'Gold',
    link: 'https://eduraw-toolkit-au-fe-en.vercel.app/single',
  }


]

export default App;

